var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpt-detail-field"},[_c('span',{staticClass:"kpt-detail-field-label has-text-grey",style:(`width:${_vm.labelWidth}px;min-width:${_vm.labelWidth}px;`)},[_vm._t("label"),_c('span',[_vm._v(":")])],2),_c('span',{staticClass:"kpt-detail-field-value"},[_vm._t("value")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }